/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import IAppNotificationItem from "./IAppNotificationItem";

export default interface AppNotificationsState {
    istDrawerOffen: boolean;
    items: IAppNotificationItem[];
    klingeln: boolean;
    itemImDialog: IAppNotificationItem | null;
}

export const createInitialState = (): AppNotificationsState => ({
    istDrawerOffen: false,
    items: [],
    klingeln: false,
    itemImDialog: null
});
